.loading {
    padding: 7px 0 7px 9px;
    color: var(--grey-lt);
}

.contact-select {
    margin-bottom: 16px;
}
